import { render, staticRenderFns } from "./red-whatsapp.vue?vue&type=template&id=620ee8c4&scoped=true"
import script from "./red-whatsapp.vue?vue&type=script&lang=js"
export * from "./red-whatsapp.vue?vue&type=script&lang=js"
import style0 from "./red-whatsapp.vue?vue&type=style&index=0&id=620ee8c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "620ee8c4",
  null
  
)

export default component.exports